// extracted by mini-css-extract-plugin
export default {"spinner-container":"Spinner_spinner-container__ZqyHa","spinner":"Spinner_spinner__BUdVj","spin":"Spinner_spin__oVtRk"};